import type { AIVoice } from 'js/src/client';
import type { VOICE_SELECTION_MODAL_SOURCE } from 'js/src/data/modals';

export enum TableRowType {
    Group = 'group',
    Voice = 'voice',
    AddYourOwn = 'add_your_own',
}

export enum GroupRowType {
    Private = 'private',
    Public = 'public',
    Legacy = 'legacy',
}

export type GroupRow = { type: TableRowType.Group; id: GroupRowType; title: string };
export type VoiceRow = { type: TableRowType.Voice; voice: AIVoice };
export type AddYourOwnRow = { type: TableRowType.AddYourOwn };
export type AIVoiceTableRow = GroupRow | VoiceRow | AddYourOwnRow;

export type VoiceSelectionModalPresentationProps = {
    isShowing: boolean;
    source?: VOICE_SELECTION_MODAL_SOURCE | null;
    initialSelectedVoiceId?: string | null;
    initialVoiceSpeed?: number | null;
    onRemoveVoiceover?: VoidFunction;
    onApply?: (voice: AIVoice, newVoiceSpeed: number | null) => void;
    onBack?: VoidFunction;
};
